import { faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import loadingSpinner from "../../assets/hostingLoading.gif";

const TimeBox = ({ value, label }) => (
    <div className="flex flex-col items-center bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-2xl shadow-e0 px-4 py-6 sm:px-6 sm:py-8">
        <h3 className="text-4xl sm:text-5xl font-extrabold bg-gradient-to-br from-rose-400 to-orange-400 bg-clip-text text-transparent tabular-nums">
            {value}
        </h3>
        <p className="mt-2 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">{label}</p>
    </div>
);

const CountDown = () => {
  const[days, setDays] = useState(10);
  const[hours, setHours] = useState(10);
  const[minutes, setMinutes] = useState(10);
  const[seconds, setSeconds] = useState(10);
  const [isLoading, setIsLoading] = useState(true)

  const countDown = () => {
    const endDate = new Date("November 25, 2021 00:00:00").getTime();
    const today = new Date().getTime();

    const timeDiff = endDate - today;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let timeDays = Math.floor((timeDiff / days));
    let timeHours = Math.floor((timeDiff % days) / hours);
    let timeMinutes = Math.floor((timeDiff % hours) / minutes);
    let timeSeconds = Math.floor((timeDiff % minutes) / seconds);

     timeHours = timeHours < 10 ? "0" + timeHours : timeHours;
     timeMinutes = timeMinutes < 10 ? "0" + timeMinutes : timeMinutes;
     timeSeconds = timeSeconds < 10 ? "0" + timeSeconds : timeSeconds;

    setDays(timeDays);
    setHours(timeHours);
    setMinutes(timeMinutes);
    setSeconds(timeSeconds);
    setIsLoading(false)

  }
  useEffect(()=> {
    const timer = setInterval(countDown, 1000)
    return () => clearInterval(timer)
  }, [])



    return (
     <>
     {isLoading ? <div
        className="w-full flex justify-center items-center"
        style={{ height: "80vh" }}
      >
        <img src={loadingSpinner} alt="loading spinner" />
      </div> :  <section className="flex items-center justify-center px-4" style={{ minHeight: "80vh" }}>
        <div className="text-center w-full max-w-3xl mx-auto">
          <FontAwesomeIcon icon={faClock} size="4x" className="text-rose-400 mb-4" />
          <h1 className="text-2xl sm:text-4xl font-extrabold text-gray-900 dark:text-white mb-8">
            Web Hosting + Free Domain
          </h1>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            <TimeBox value={days} label="Days" />
            <TimeBox value={hours} label="Hours" />
            <TimeBox value={minutes} label="Minutes" />
            <TimeBox value={seconds} label="Seconds" />
          </div>
        </div>
  </section>}
     </>
    );
};

export default CountDown;
